import { jwtDecode } from 'jwt-decode';

interface PermissionTokenPayload {
  permission?: unknown;
  permissions?: unknown;
}

function coerceToStringArray(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((item): item is string => typeof item === 'string');
  }
  if (typeof value === 'string') {
    return [value];
  }
  return [];
}

export function decodePermissions(token: string): string[] {
  try {
    const payload = jwtDecode<PermissionTokenPayload>(token);
    const raw = payload.permissions ?? payload.permission;
    return coerceToStringArray(raw);
  } catch {
    return [];
  }
}

export function hasPermission(permissions: string[], permission: string): boolean {
  return permissions.some(p => p.toLowerCase() === permission.toLowerCase());
}

export function hasAnyPermission(permissions: string[], required: string[]): boolean {
  return required.some(r => hasPermission(permissions, r));
}

export function canManageUsersAnyOrg(permissions: string[]): boolean {
  return hasPermission(permissions, 'User:Create:AnyGroup');
}
